export default __webpack_public_path__ + "static/product-outdoor-enclosure-c71fb025ba6e944f56f7c6e2c799a894.png";